import { render } from "./CloudSegment.vue?vue&type=template&id=5884097e&scoped=true"
import script from "./CloudSegment.vue?vue&type=script&lang=ts"
export * from "./CloudSegment.vue?vue&type=script&lang=ts"

import "./CloudSegment.vue?vue&type=style&index=0&id=5884097e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5884097e"

export default script